import { PersonaProfile, PersonaUserProfile } from './persona-profile';
import { User } from './user';

export class PersonaUser implements User {
  kind: 'persona';
  accessToken: string;
  activePid: string;
  guid: string;
  isAnonymous = false;
  profile: PersonaUserProfile | undefined;
  scopes: string[];

  constructor(private loginResponse: PersonaProfile) {
    this.accessToken = this.loginResponse.oauth.access_token;
    this.activePid = this.loginResponse.active_pid;
    this.guid = this.loginResponse.guid;
    this.profile = this.loginResponse.profile;
    this.scopes = this.loginResponse.oauth.scope;
  }

  get fullName(): string | undefined {
    const { first_name = undefined, surname = undefined } = this.profile || {};

    if (first_name && surname) {
      return `${first_name} ${surname}`;
    }

    return undefined;
  }

  cloneWithProfile(profile: PersonaUserProfile): PersonaUser {
    const updatedUser = new PersonaUser(this.loginResponse);
    updatedUser.profile = profile;
    return updatedUser;
  }
}
